export const FACEBOOK =
  'https://www.facebook.com/spotjobsapp/?modal=admin_todo_tour'
export const TWITTER = 'https://twitter.com/SpotJobsApp1'
export const INSTAGRAM = 'https://www.instagram.com/spotjobsapp/'
export const LINKEDIN = 'https://www.linkedin.com/company/spotjobs-app'
